import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getScriberequest,
  editScriberequest,
} from "../../store/actions/scriberequests_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import {
  initialValues,
  inputFields,
} from "../../shared/enums/scriberequests_enum";

const EditScriberequest = ({
  editScriberequest,
  getScriberequest,
  match,
  scriberequest: { loading, scriberequest },
}) => {
  let history = useHistory();
  useEffect(() => {
    getScriberequest(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitScriberequest = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editScriberequest(scriberequest.id, values);
    history.push(`/scriberequests/${scriberequest.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Scriberequest"
          mainLinkTitle="Scriberequests"
          mainLinkUrl="/scriberequests"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              scriberequest && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {scriberequest[Object.keys(inputFields)[0]]} -{" "}
                        <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to="/scriberequests"
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> Scriberequests
                        </Link>
                        <Link
                          to={`/scriberequests/${scriberequest.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={scriberequest}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitScriberequest}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  scriberequest: state.scriberequest,
});

const mapDispatchToProps = { editScriberequest, getScriberequest };

export default connect(mapStateToProps, mapDispatchToProps)(EditScriberequest);
